import Vue from 'vue'
import { fetchProfile } from '@/api/auth'
import { clearNotificationState } from '@/store/notification'
import {
  clearStoredSession,
  getStoredProfile,
  getToken,
  setStoredProfile,
  setToken
} from '@/utils/auth'

export const sessionState = Vue.observable({
  token: getToken(),
  profile: getStoredProfile(),
  loading: false
})

export const isAuthenticated = () => Boolean(sessionState.token)

export const applyAuthSession = (payload = {}) => {
  const nextToken = payload.token || ''
  const nextProfile = payload.member_info || null

  sessionState.token = nextToken
  sessionState.profile = nextProfile

  setToken(nextToken)
  setStoredProfile(nextProfile)
}

export const setProfile = (profile) => {
  sessionState.profile = profile || null
  setStoredProfile(profile || null)
}

export const clearSession = () => {
  sessionState.token = ''
  sessionState.profile = null
  sessionState.loading = false
  clearNotificationState()
  clearStoredSession()
}

export const hydrateSession = async () => {
  if (!sessionState.token) {
    return null
  }

  if (sessionState.loading) {
    return sessionState.profile
  }

  sessionState.loading = true

  try {
    const profile = await fetchProfile()
    setProfile(profile)
    return profile
  } catch (error) {
    clearSession()
    throw error
  } finally {
    sessionState.loading = false
  }
}
